// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// import { getAuth } from "firebase/auth";
// import { getDatabase } from "firebase/database";
// import { getStorage } from "firebase/storage";

// const firebaseConfig = {
//   apiKey: "AIzaSyAGpznqp-blzbe076TnNpxLFXh3mawsTQY",
//   authDomain: "nodejs-2d35a.firebaseapp.com",
//   databaseURL: "https://nodejs-2d35a-default-rtdb.firebaseio.com",
//   projectId: "nodejs-2d35a",
//   storageBucket: "nodejs-2d35a.appspot.com",
//   messagingSenderId: "794426375729",
//   appId: "1:794426375729:web:252f3e69d8eed8de9e9f10",
//   measurementId: "G-HSEHMJLNV1"
// };

// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
// const auth = getAuth(app);
// const db = getDatabase(app);
// const storage = getStorage(app);


// const database = db;

// export { auth, db, database, storage, analytics };




import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getDatabase(app);
const storage = getStorage(app);

const database = db;

export { auth, db, database, storage, analytics };
